<div>
    <div class="my-2">
        <select class="form-select" [(ngModel)]="familleActe">
            <option value="">Toutes les familles</option>
            <option *ngFor="let famille of famillesUniques" [value]="famille">
                {{famille}}
            </option>
        </select>
    </div>
    
    <input type="text" class="form-control my-2" [(ngModel)]="actes"  
           placeholder="Recherche Acte">
    
    <nav class="tree-nav scroll">
        <div class="flex" *ngFor="let act of values | filterAct:actes:familleActe; let i = index">
            <div class="d-flex justify-content-start align-items-start flex-column">
                <span class="label">{{act.actes.desc_Acte}}</span>
                <span class="fw-bold text-danger">{{act.actes.cnam_ACT_COD}}</span>
                <small *ngIf="act.actes?.famille_Acte" class="text-muted">
                    Famille: {{act.actes.famille_Acte}}
                </small>
            </div>
            <input type="checkbox" name="" id="" class="checkbox" 
                   (change)="changed(act,$event,i)">
        </div>
    </nav>
    
    <button class="btn btn-primary ajouter" (click)="close()">Ajouter</button>
</div>